import { compact } from 'lodash'

import { Translation } from '@marketplace-web/i18n/i18n-data'

import {
  Conversation,
  ConversationMessage,
  InboxConversationListItemDto,
  OppositeUser,
} from '../types/conversation'
import {
  ConversationMessageNewDto,
  ConversationNewDto,
  ConversationOppositeUserNewDto,
  InboxConversationListItemDtoNew,
} from '../types/conversation-new'
import { transformMessage } from './conversation'

// TO DO: add missing types when available
const transformInboxConversationListItemDtoNew = (
  conversationListItem: InboxConversationListItemDtoNew,
): InboxConversationListItemDto => ({
  id: conversationListItem.id,
  last_message_id: conversationListItem.last_message.id || null,
  description: conversationListItem.last_message.data.content,
  item_count: conversationListItem.data.inventory_items.length,
  item_photos: [],
  opposite_user: {
    id: conversationListItem.data.opposite_user.id,
    badge: null,
    login: conversationListItem.data.opposite_user.login_name,
    photo: null,
  },
  unread: conversationListItem.is_unread_by_current_user,
  updated_at: conversationListItem.created_at,
})

export const transformInboxConversationListItemDtosNew = (
  conversationListItems: Array<InboxConversationListItemDtoNew>,
): Array<InboxConversationListItemDto> =>
  conversationListItems.map(transformInboxConversationListItemDtoNew)

const transformConversationOppositeUserNew = (
  oppositeUser: ConversationOppositeUserNewDto,
): OppositeUser => ({
  id: oppositeUser.id,
  city: null,
  localCountryTitle: '',
  isLocationExposed: null,
  login: oppositeUser.login_name,
  lastLoginTime: undefined,
  feedbackCount: null,
  feedbackReputation: 1,
  profileUrl: '',
  photo: null,
  photoThumbnail: null,
  isSystem: false,
  isHated: false,
  isUserUnblockable: false,
  reviewCount: undefined,
  locationDescription: undefined,
})

const transformMessageNewEntity = (message: ConversationMessageNewDto): ConversationMessage => ({
  createdTime: message.data.created_at_ts,
  createdRelativeTime: message.data.created_time_ago,
  entityType: message.data.entity_type,
  message: transformMessage(message.data),
})

export const transformConversationNewResponse = (response: ConversationNewDto): Conversation => ({
  id: response.id,
  messages: compact(response.messages.map(transformMessageNewEntity)),
  transactionId: undefined,
  isTranslated: false,
  oppositeUser:
    response.data.opposite_user &&
    transformConversationOppositeUserNew(response.data.opposite_user),
  buyerId: undefined,
  isPaymentActionAvailable: false,
  translationType: Translation.None,
  isReadByOppositeUser: false,
  itemId: response.data.items[0]?.inventory_item_id
    ? Number(response.data.items[0].inventory_item_id)
    : undefined,
  isReplyAllowed: true,
  isSuspicious: false,
  isDeletionRestricted: false,
  isBundleAvailable: false,
  transaction: null,
  suggestedMessages: [],
  item: null,
  education: null,
  moderatedItems: null,
  isControl: false,
  userHasSupportRole: false,
  isFirstTimeListerEducationRequired: false,
  orderDetailsVariant: 'off',
  germanyBannerMetadata: undefined,
})
